<div class="weblinks-part">
	@if(!showForm() || values().webLinkId != 0){
	<button class="btn btn-standard mb-3" (click)="showAddForm()">Add a WebLink</button>
	} @else {
	<ng-container *ngTemplateOutlet="webLinkFormTemplate"></ng-container>
	}

	@for(link of webLinks(); track link.webLinkId; let idx = $index) {
	@if(values().webLinkId != link.webLinkId){
	<div class="d-flex justify-content-between gap-4 my-2">
		<div class="d-flex align-items-center">
			<i class='fs-5 me-2' [ngClass]="[link.icon]"></i>
			<div class="web-link text-break m-1">{{link.url}}</div>
		</div>

		<common-button-row [center]="true">
			<button class="btn btn-standard" (click)="editWebLink(link.webLinkId, link.webLinkTypeId, link.url)">
				<i class="fa-regular fa-pen-to-square"></i>
			</button>
			<button class="btn btn-standard" (click)="confirmWebLinkDeletion(link)">
				<i class='fa-regular fa-trash'></i>
			</button>
		</common-button-row>
	</div>
	} @else {
	<ng-container *ngTemplateOutlet="webLinkFormTemplate"></ng-container>
	}
	}


	<ng-template #webLinkFormTemplate let-hide="hide">
		<div class="d-flex align-items-baseline gap-2" [class.d-none]="hide">
			<common-select-field [field]="linkType()" class="flex-even"></common-select-field>
			<common-url-field [field]="url()" class="flex-even"></common-url-field>

			<common-button-row [center]="true">
				<button class="btn" [class.btn-primary]="form.allValidWithoutError()" (click)="saveOrUpdateWebLink()">
					<i class="fa-solid fa-check"></i>
				</button>

				<button class="btn btn-standard" (click)="closeForm()">
					<i class='fa-regular fa-xmark'></i>
				</button>
			</common-button-row>
		</div>
	</ng-template>
</div>